module.exports = __webpack_public_path__ + "static/img/logoText.3a5bac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoText.png
// module id = 204
// module chunks = 1